<template>
<div>
    <template v-if="action=='view'">
        <div class="table-settings mb-4" v-if="allData.length>0">
            <div class="row align-items-center justify-content-between">
                <div class="col col-md-6 col-lg-3 col-xl-4">
                </div>
                <div class="col col-md-6 col-lg-3 col-xl-4 text-right">
                    <a href="https://5ineprojects.com/Rapidea/backend/api/Transaction.php" class="btn btn-primary" download>Download Excel</a>

                </div>
            </div>
        </div>
        <div class="card border-light shadow-sm mb-4">
            <div class="card-body" v-if="loading==false && (allData.length>0 || q!='')">
                <table class="table table-hover">
                    <thead class="thead-light">
                        <tr>
                            <th>#</th>
                            <th>Username</th>
                            <th>Payment Date</th>
                            <th>Total Amount</th>
                            <th>Payment type</th>
                            <th>Order Status</th>
                        </tr>
                    </thead>
                    <tbody v-if="allData.length>0">
                        <tr v-for="(data,key) in allData" :key="key">
                            <td>
                                <a href="#" class="font-weight-bold">
                                    {{key+1}}
                                </a>
                            </td>
                            <td><span class="font-weight-normal">{{data.username}}</span>
                            </td>
                            <td>
                                {{data.udate}}
                            </td>
                            <td>
                                {{data.amount}}
                            </td>
                            <td><span class="font-weight-bold">
                                    <a class="btn-success btn  btn-xs" v-if="data.type=='deposit'" href="#"> {{data.type}} </a>
                                    <a class="btn-danger btn  btn-xs" v-if="data.type=='credit'" href="#"> {{data.type}}</a>
                                </span></td>
                            <td><span class="font-weight-bold">
                                    <a class="btn-success btn  btn-xs" v-if="data.status==1" href="#"> Completed </a>
                                    <a class="btn-danger btn  btn-xs" v-if="data.status==0" href="#"> Pending</a>
                                </span></td>
                        </tr>
                    </tbody>
                    <tbody v-else>
                        <tr>
                            <td class="text-center" colspan="5">No record found</td>
                        </tr>
                    </tbody>
                </table>
                <div class="card-footer px-3 border-0 d-flex align-items-center justify-content-between">
                    <nav aria-label="Page navigation example">
                        <ul class="pagination mb-0">
                            <template v-for="(paginate,key) in allData.links">
                                <li :key="key" class="page-item" :class="{'active': paginate.active}" v-if="paginate.url">
                                    <a class="page-link" @click="viewAllUrl=paginate.url;allDatas(false)" v-html="paginate.label"></a>
                                </li>
                            </template>
                        </ul>
                    </nav>
                    <div class="font-weight-bold small">Page <b>{{allData.current_page}}</b> of <b>{{allData.last_page}}</b> page Total record <b>{{allData.total}}</b></div>
                </div>
            </div>
            <div class="card-body text-center" v-else>
                <div v-if="loading">
                    loading...
                </div>
                <div v-else>
                    <!-- <InlineSvg name="nopage"></InlineSvg> -->
                    <div>
                        <h3>Add and manage your {{page}}</h3>
                        <p>This is where you’ll add {{page}} and manage your website. You can also improve your seo for {{page}} by adding.</p>
                        <router-link :to="{name : 'index', params: { page: page, action: 'add' }}" class="btn btn-primary" type="button">Add {{page}}</router-link>
                        <br><br><br>
                    </div>
                </div>
            </div>
        </div>
    </template>
    <template v-else>
        <div class="row">
            <div class="col-12 col-xl-8">
                <div class="card card-body bg-white border-light shadow-sm mb-4">
                    <h2 class="h5 mb-4">General information </h2>
                    <div class="row">
                        <!-- <div class="col-md-6 mb-3">
                                <MssInput v-model="form.linkname" placeholder="Enter Page Link" required></MssInput>
                            </div> -->
                        <div class="col-md-6 mb-3">
                            <MssInput v-model="form.username" placeholder="Enter Fullname" required></MssInput>
                        </div>
                        <div class="col-md-6 mb-3">
                            <MssInput v-model="form.mobile" placeholder="Enter Mobile Number" required></MssInput>
                        </div>
                        <div class="col-md-6 mb-3">
                            <MssInput v-model="form.email" placeholder="Enter Mobile Email" required></MssInput>
                        </div>
                        <div class="col-md-6 mb-3">
                            <MssInput v-model="form.pass" placeholder="Enter password" required></MssInput>
                        </div>
                        <div class="col-md-6 mb-3">
                            <MssInput v-model="form.state" placeholder="Enter State name" required></MssInput>
                        </div>
                        <div class="col-md-6 mb-3">
                            <MssInput v-model="form.city" placeholder="Enter City Name" required></MssInput>
                        </div>
                        <div class="col-md-6 mb-3">
                            <MssInput v-model="form.zip" placeholder="Enter Pincode" required></MssInput>
                        </div>

                    </div>
                </div>
            </div>
            <div class="col-12 col-xl-4 sidebar-stricky">
                <div class="card card-body bg-white border-light shadow-sm mb-4">
                    <h2 class="h5 mb-4">Visibility</h2>
                    <div class="row">
                        <div class="col-md-12 mb-3">
                            <MssInput type="switch" v-model="form.status" placeholder="Visible this page to all"></MssInput>
                        </div>
                        <div class="col-md-12 mb-3">
                            <div>
                                <button @click="submit" class="btn btn-info btn-block" v-if="action=='add'">Publish</button>
                                <button @click="submit" class="btn btn-success btn-block" v-else>Update</button>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </template>
</div>
</template>

<script>
import axios from 'axios'
import $ from 'jquery'

export default {
    components: {},
    props: [
        "page", "action", "id"
    ],
    data() {
        return {
            showModal: false,
            isEditor: true,
            q: '',
            loading: false,
            allData: [],
            form: {
                id: null,
                status: true,
                type: 'add_user',
                username: '',
                email: '',
                mobile: '',
                password: '',
                state: '',
                city: '',
                zip: '',
            },
            editSEO: false,
            defaultSEO: true,
            pageList: [],
            fullToolbar: [
                [{
                    'font': []
                }],
                [{
                    'header': [false, 1, 2, 3, 4, 5, 6, ]
                }],
                [{
                    'size': ['small', false, 'large', 'huge']
                }],
                ['bold', 'italic', 'underline', 'strike'],
                [{
                    'align': [false, 'justify', 'center', 'right']
                }],
                //[{ 'header': 1 }, { 'header': 2 }],
                //['blockquote', 'code-block'],
                [{
                    'list': 'ordered'
                }, {
                    'list': 'bullet'
                }, {
                    'list': 'check'
                }],
                //[{ 'script': 'sub'}, { 'script': 'super' }],
                [{
                    'indent': '-1'
                }, {
                    'indent': '+1'
                }],
                [{
                    'color': []
                }, {
                    'background': []
                }],
                ['link', 'image', 'video', 'formula'],
                //[{ 'direction': 'rtl' }],
                ['clean'],
            ],
            viewAllUrl: ''
        }
    },
    methods: {
        update(table, status, id) {
            var param = {
                id: id,
                status: status,
                table: table,
                type: 'commonStatus'
            }
            axios({
                method: 'POST',
                url: this.$root.URL_ROOT + 'api.php',
                data: param
            }).then(function (response) {
                var data = response.data;
                console.log('status', data)
            })
        },
        addInit() {
            this.getUnderof();
            this.reset()
        },
        editInit() {
            this.getDetail();
            this.getUnderof();
        },
        viewInit() {
            this.viewAllUrl = this.URL_ROOT + 'admin/' + this.page + '/all'
            this.allDatas(true)
        },
        reset() {
            this.form = {
                id: null,
                status: true,
                type: 'add_user',
                username: '',
                email: '',
                mobile: '',
                pass: '',
                state: '',
                city: '',
                zip: '',
            };
        },
        getUnderof() {
            var pList = [];
            pList.push({
                label: 'Primary Menu',
                code: 0
            })
            $.ajax({
                "method": 'GET',
                "url": this.URL_ROOT + 'admin/' + this.page + '/allpage/?field=heading,id,underof',
                "success": (response) => {
                    if (response.status == "success") {
                        console.log(response.data);
                        $.each(response.data, function (key, param) {
                            //console.log(param,key);
                            pList.push({
                                label: param.heading,
                                code: param.id
                            })
                        })
                    }
                    this.pageList = pList;
                }
            })
        },
        getDetail() {
            var ev = this
            var param = {
                uid: this.id,
                type: 'userDetail'
            }
            axios({
                method: 'POST',
                url: this.$root.URL_ROOT + 'api.php',
                data: param
            }).then(function (response) {
                console.log(response.data.data)
                var data = response.data;
                ev.form = data.data
            })
        },
        allDatas() {
            var ev = this
            axios({
                method: 'POST',
                url: this.$root.URL_ROOT + 'api.php',
                data: {
                    type: 'allTransaction',
                }
            }).then(function (response) {
                console.log(response.data);
                var data = response.data;
                ev.allData = data.data
            })
        },
        submit() {
            var ev = this

            if (this.form.username === '') {
                this.$toasted.global.error({
                    message: 'Please enter Full Name'
                })
            } else if (this.form.email === '') {
                this.$toasted.global.error({
                    message: 'Please enter Email'
                })
            } else if (this.form.mobile === '') {
                this.$toasted.global.error({
                    message: 'Please enter mobile'
                })
            } else if (this.form.pass === '') {
                this.$toasted.global.error({
                    message: 'Please enter password'
                })
            } else if (this.form.state === '') {
                this.$toasted.global.error({
                    message: 'Please enter State'
                })
            } else if (this.form.city === '') {
                this.$toasted.global.error({
                    message: 'Please enter City'
                })
            } else if (this.form.zip === '') {
                this.$toasted.global.error({
                    message: 'Please enter Pincode'
                })
            } else {
                var status = ''
                if (ev.form.status == true) {
                    status = 1
                } else {
                    status = 0
                }
                let formData = new FormData();
                if (this.action == 'edit') {
                    this.form.type = 'edit_user';
                    formData.append('uid', this.id);

                }
                formData.append('fullname', ev.form.username);
                formData.append('mobile', ev.form.mobile);
                formData.append('email', ev.form.email);
                formData.append('password', ev.form.pass);
                formData.append('state', ev.form.state);
                formData.append('city', ev.form.city);
                formData.append('pincode', ev.form.zip);
                formData.append('status', status);
                formData.append('type', ev.form.type);
                axios({
                    method: 'POST',
                    url: this.$root.URL_ROOT + 'api.php',
                    data: formData
                }).then(function (response) {
                    var data = response.data;
                    console.log(response)
                    if (data.status == "success") {
                        ev.$swal({
                            toast: true,
                            position: 'top-end',
                            timer: 5000,
                            icon: 'success',
                            timerProgressBar: true,
                            title: 'Action perform successfully'
                        })
                        //  window.location.href = 'index/'+ev.page;
                        ev.$router.push({
                            name: 'index',
                            params: {
                                page: ev.page,
                            }
                        })
                    } else {
                        setTimeout(() => ev.$swal(data.msg), 1000);

                    }

                })
            }
        },
        remove(id) {
            var self = this;
            var param = {
                id: id,
                table: 'mss_site_user',
                type: 'commonDelete'
            }
            this.$swal({
                title: "Delete this ?",
                text: "Are you sure? You won't be able to revert this!",
                icon: 'info',
                showCancelButton: true,
                confirmButtonColor: "#f00",
                confirmButtonText: "Yes, Delete it!",
                reverseButtons: true
            }).then((result) => {
                if (result.isConfirmed) {
                    axios({
                        method: 'POST',
                        url: this.$root.URL_ROOT + 'api.php',
                        data: param
                    }).then(function (response) {
                        var data = response.data;
                        self.allDatas()
                        console.log('commonDelete', data)
                    })
                }
            })
        },

    },
    mounted() {
        if (this.action == "view") {
            this.viewInit()
        } else if (this.action == "edit" && this.id > 0) {
            this.editInit()
        } else if (this.action == "add") {
            this.addInit();
        }
    },
    watch: {
        'action': function (val) {
            if (val == "view") {
                this.viewInit()
            } else if (val == "edit" && this.id > 0) {
                this.editInit()
            } else if (val == "add") {
                this.addInit();
            }
        },
    }
}
</script>

<style scoped>
@import "~vue2-editor/dist/vue2-editor.css";

.link {
    color: #fff !important;
}
</style>
